

export class HRKraHRGoal {
    hrKRAId:          string;
    hrGoalId:         string;
    hrGoalTitle:      string;
    hrKRATitle:       string;
}